import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/assets/categories/63-moto-accesorios-bolsas-motos.svg")